import { createRoutine } from 'redux-saga-routines';

export const fetchAllEmailCampaigns = createRoutine(
  'FETCH_ALL_EMAIL_CAMPAIGNS'
);
export const fetchEmailCampaignById = createRoutine(
  'FETCH_EMAIL_CAMPAIGN_BY_ID'
);
export const fetchRecipientsByCampaignId = createRoutine(
  'FETCH_RECIPIENT_BY_CAMPAIGN_ID'
);
export const fetchRecipientStatsByCampaignId = createRoutine(
  'FETCH_RECIPIENT_STATS_BY_CAMPAIGN_ID'
);
export const fetchEngagementMetricsByCampaignId = createRoutine(
  'FETCH_ENGAGEMENT_METRICS_BY_CAMPAIGN_ID'
);
export const fetchLineGraphMetricsByCampaignId = createRoutine(
  'FETCH_LINE_GRAPH_METRICS_BY_CAMPAIGN_ID'
);
